import {
  GET_PHAN_QUYEN_CAM_DO,
  GET_PHAN_QUYEN_CAM_DO_SUCCESS,
  GET_PHAN_QUYEN_CAM_DO_FAILURE,
  GET_PHAN_QUYEN_TIN_CHAP,
  GET_PHAN_QUYEN_TIN_CHAP_SUCCESS,
  GET_PHAN_QUYEN_TIN_CHAP_FAILURE,
  GET_PHAN_QUYEN_NO_PHAI_THU,
  GET_PHAN_QUYEN_NO_PHAI_THU_SUCCESS,
  GET_PHAN_QUYEN_NO_PHAI_THU_FAILURE,
  GET_PHAN_QUYEN_TRA_GOP,
  GET_PHAN_QUYEN_TRA_GOP_SUCCESS,
  GET_PHAN_QUYEN_TRA_GOP_FAILURE,
} from './actionTypes';
export const getPhanQuyenTinChap = (dataSearch) => ({
  type: GET_PHAN_QUYEN_TIN_CHAP,
  dataSearch,
});

export const getPhanQuyenTinChapSuccess = (data) => ({
  type: GET_PHAN_QUYEN_TIN_CHAP_SUCCESS,
  payload: data,
});

export const getPhanQuyenTinChapFailure = () => ({
  type: GET_PHAN_QUYEN_TIN_CHAP_FAILURE,
});
export const getPhanQuyenNoPhaiThu = (dataSearch) => ({
  type: GET_PHAN_QUYEN_NO_PHAI_THU,
  dataSearch,
});

export const getPhanQuyenNoPhaiThuSuccess = (data) => ({
  type: GET_PHAN_QUYEN_NO_PHAI_THU_SUCCESS,
  payload: data,
});

export const getPhanQuyenNoPhaiThuFailure = () => ({
  type: GET_PHAN_QUYEN_NO_PHAI_THU_FAILURE,
});

export const getPhanQuyenCamDo = (dataSearch) => ({
  type: GET_PHAN_QUYEN_CAM_DO,
  dataSearch,
});

export const getPhanQuyenCamDoSuccess = (data) => ({
  type: GET_PHAN_QUYEN_CAM_DO_SUCCESS,
  payload: data,
});

export const getPhanQuyenCamDoFailure = () => ({
  type: GET_PHAN_QUYEN_CAM_DO_FAILURE,
});

export const getPhanQuyenTraGop = (dataSearch) => ({
  type: GET_PHAN_QUYEN_TRA_GOP,
  dataSearch,
});

export const getPhanQuyenTraGopSuccess = (data) => ({
  type: GET_PHAN_QUYEN_TRA_GOP_SUCCESS,
  payload: data,
});

export const getPhanQuyenTraGopFailure = () => ({
  type: GET_PHAN_QUYEN_TRA_GOP_FAILURE,
});
